import Vue from 'vue'
import { apiRoutes } from '@/helpers/ApiRoutes'

const RESET_PIN_TOKEN_REQUEST_PARAM_KEY = 'resetPinToken'
const RESET_PIN_APP_ID_SESS_KEY = 'reset_pin_app_id'

export const PinResetMixin = Vue.extend({
  methods: {
    getResetPinInitUrl (): string {
      return (process.env.VUE_APP_AXIOS_BASE_URL + apiRoutes.resetPinInit)
    },
    resetPin (token: string) {
      const params = new URLSearchParams()
      params.append(RESET_PIN_TOKEN_REQUEST_PARAM_KEY, token)

      return this.$axios.post(apiRoutes.resetPin, params)
    },
    setResetPinAppIdInStorage (appId: string) {
      localStorage.setItem(RESET_PIN_APP_ID_SESS_KEY, appId)
    },
    getResetPinAppIdFromStorage (): number {
      const appId = localStorage.getItem(RESET_PIN_APP_ID_SESS_KEY)
      localStorage.removeItem(RESET_PIN_APP_ID_SESS_KEY)
      return typeof appId === 'string' ? parseInt(appId) : 0
    }
  }
})
